export const GROUP_DESCRIPTION_MAX_LENGTH = 2000;
export const GROUP_TITLE_MAX_LENGTH = 255;
